//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { bvTnCUrls } from '@legacy-components/rights-management/request-rights-util';
import { useRightsRequestTCUrl } from '@uia/rights/hooks/useRightsRequestTCUrl';
import { getIsRightsRequestTermsAndConditionsEnabled } from '@uia/rights/selectors/getUIARights';
import { hasWellFormattedUrl } from '@uia/rights/utils/urlUtils';
import { isDefined } from '@utils/filterPredicates';

export const useIsMessageMissingTCUrl = (rightsRequestText?: string) => {
  const isRightsRequestTermsAndConditionsEnabled = useSelector(
    getIsRightsRequestTermsAndConditionsEnabled,
  );

  const rightsRequestTCUrl = useRightsRequestTCUrl();

  const bvTCUrlsAndCustomUrls = [
    ...bvTnCUrls,
    ...(isDefined(rightsRequestTCUrl) ? [rightsRequestTCUrl] : []),
  ];

  const hasTCUrlMatch = bvTCUrlsAndCustomUrls.some((url) =>
    hasWellFormattedUrl(rightsRequestText || '', url),
  );

  return (
    isRightsRequestTermsAndConditionsEnabled &&
    isDefined(rightsRequestText) &&
    !hasTCUrlMatch
  );
};
